export default __webpack_public_path__ + "static-json/ne_110m_land-d6dc1551b7f81743d5ac8aed5cca6d38.json";